import React, { useState } from 'react';
import { FaUserMd, FaEdit, FaTrash } from 'react-icons/fa';
import HospitalNavbar from './HospitalNavbar';
import './HospitalDashboard.css';

const Doctors = () => {
  const [doctors] = useState([
    {
      id: 1,
      name: 'Dr. John Smith',
      specialization: 'Cardiologist',
      experience: '15 years',
      contact: '+1 234-567-8900',
      email: 'john.smith@hospital.com'
    },
    {
      id: 2,
      name: 'Dr. Emma Wilson',
      specialization: 'Neurologist',
      experience: '10 years',
      contact: '+1 234-567-8901',
      email: 'emma.wilson@hospital.com'
    },
    // Add more doctors as needed
  ]);

  return (
    <div className="dashboard-container">
      <HospitalNavbar />
      <div className="dashboard-content">
        <header className="dashboard-header">
          <h1>Doctors Management</h1>
          <div className="user-profile">
            <span>Dr. Sarah Johnson</span>
            <div className="profile-image">SJ</div>
          </div>
        </header>

        <div className="stats-container">
          <div className="stat-card">
            <div className="stat-icon" style={{ backgroundColor: '#3498db' }}>
              <FaUserMd />
            </div>
            <div className="stat-details">
              <h3>Total Doctors</h3>
              <p className="stat-count">{doctors.length}</p>
            </div>
          </div>
        </div>

        <div className="dashboard-widgets">
          <div className="widget doctors-list">
            <div className="widget-header">
              <h2>Doctors Directory</h2>
              <button className="add-doctor-btn">Add New Doctor</button>
            </div>
            <table className="doctors-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Specialization</th>
                  <th>Experience</th>
                  <th>Contact</th>
                  <th>Email</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {doctors.map(doctor => (
                  <tr key={doctor.id}>
                    <td>{doctor.name}</td>
                    <td>{doctor.specialization}</td>
                    <td>{doctor.experience}</td>
                    <td>{doctor.contact}</td>
                    <td>{doctor.email}</td>
                    <td>
                      <button className="action-btn edit"><FaEdit /></button>
                      <button className="action-btn delete"><FaTrash /></button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Doctors;